<script setup>
import Popper from 'vue3-popper'

const props = defineProps({
    blockId: {
        type: String,
        default: () => ''
    },
    mapData: {
        type: Object,
        default: () => {}
    }
})

const handlePopperOpen = (event) => {
    let current = event.currentTarget

    current.querySelector('.popper').style.width = 'max-content'

    // get siblings
    let siblings = [...current.parentElement.children].filter((el) => el !== current)

    // change siblings z-index to 1
    siblings.forEach((el) => {
        el.style.zIndex = 1
    })

    // change current z-index to 2
    current.style.zIndex = 2
}
</script>

<template>
     <section class="map" v-if="mapData" :id="'#'+blockId">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="title">
                        <h2 v-if="mapData.title">{{ mapData.title }}</h2>
                        <div class="buttons" v-if="mapData.buttons && mapData.buttons.length">
                            <a v-for="button in mapData.buttons" :href="button.button_link ?? '#'" :class="'c-button ' + button.button_type ?? ''">
                                {{ button.button_text ?? '' }}
                                <svg width="17px" height="18px">
                                    <use href="/img/icons/icons.svg#btnArrow"></use>
                                </svg>
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <div class="map-wrapper" v-if="mapData.map_points && mapData.map_points.length">
                <img src="/img/map.svg" :alt="mapData?.title">

                <div class="map-pins-wrapper">

                    <div v-for="map_point in mapData.map_points" class="map-pin" style="top: unset;" :style="{ left: (map_point.x_axis ?? 0)+'%', bottom: (map_point.y_axis ?? 0)+'%' }"
                         @mouseenter="handlePopperOpen($event)"
                    >

                        <Popper hover arrow class="map-popper-theme">
                            <div class="marker">
                                <svg class="hidden-xs-down" id="marker" width="82" height="91" viewBox="0 0 82 91" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g filter="url(#filter0_d_2_902)">
                                        <path
                                            d="M61.8858 16.4729C73.2786 27.8658 73.2786 46.3373 61.8857 57.7301C56.1552 63.4607 41.2572 78.3587 41.2572 78.3587C41.2572 78.3587 26.2909 63.3924 20.6286 57.7301C9.23573 46.3373 9.23573 27.8658 20.6286 16.473C32.0214 5.0801 50.4929 5.08009 61.8858 16.4729Z"
                                            fill="currentColor" />
                                        <path
                                            d="M61.8857 57.7301C56.1552 63.4607 41.2572 78.3587 41.2572 78.3587C41.2572 78.3587 26.2909 63.3924 20.6286 57.7301L41.2572 78.3587L61.8857 57.7301Z"
                                            fill="currentColor" />
                                    </g>
                                    <circle cx="41.4609" cy="37.0995" r="24.5976" fill="#D72828" />
                                    <path
                                        d="M42.4572 32.992C42.4105 31.3529 41.626 29.8234 40.3207 28.8287C39.6529 28.4131 38.9104 28.1305 38.1351 27.9951C36.7365 28.7283 35.0646 28.7283 33.6659 27.9951C32.8977 28.1329 32.1645 28.4178 31.5037 28.8287C30.1985 29.8211 29.4139 31.3529 29.3672 32.992V42.3858H33.0518V55.6346H38.6629V42.3858H42.4316L42.4572 32.992Z"
                                        fill="#F7F5F5" />
                                    <path
                                        d="M32.0451 23.711C32.0241 21.5744 33.7403 19.8278 35.8745 19.8068C38.0111 19.7858 39.7576 21.502 39.7787 23.6386C39.7997 25.7751 38.0834 27.5217 35.9492 27.5427C35.9376 27.5427 35.9236 27.5427 35.9119 27.5427C33.7917 27.5427 32.0638 25.8335 32.0451 23.711Z"
                                        fill="#F7F5F5" />
                                    <path d="M29.4673 43.3809L26.1143 46.6826V55.4015L32.1082 49.4332V43.3809H29.4673Z" fill="#F7F5F5" />
                                    <path
                                        d="M45.196 19.7931L49.2496 23.821L42.7676 30.2306C43.1972 31.0899 43.4354 32.0332 43.4657 32.9929V38.1136L53.4736 28.1431L57.7093 32.3041V19.7931H45.1983H45.196Z"
                                        fill="#F7F5F5" />
                                    <defs>
                                        <filter id="filter0_d_2_902" x="4.08398" y="3.92831" width="74.3464" height="86.4304"
                                            filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                            <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                                result="hardAlpha" />
                                            <feOffset dy="4" />
                                            <feGaussianBlur stdDeviation="4" />
                                            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0" />
                                            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2_902" />
                                            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2_902" result="shape" />
                                        </filter>
                                    </defs>
                                </svg>
                                <svg id="markerXs" class="hidden-xs-up" width="28" height="31" viewBox="0 0 28 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g filter="url(#filter0_d_1_7888)">
                                        <path
                                            d="M20.6286 5.8243C24.4262 9.62191 24.4262 15.7791 20.6286 19.5767C18.7184 21.4869 13.7524 26.4529 13.7524 26.4529C13.7524 26.4529 8.76362 21.4641 6.87619 19.5767C3.07858 15.7791 3.07858 9.62192 6.87619 5.8243C10.6738 2.02668 16.831 2.02668 20.6286 5.8243Z"
                                            fill="currentColor" />
                                        <path
                                            d="M20.6286 19.5767C18.7184 21.4869 13.7524 26.4529 13.7524 26.4529C13.7524 26.4529 8.76362 21.4641 6.87619 19.5767L13.7524 26.4529L20.6286 19.5767Z"
                                            fill="currentColor" />
                                    </g>
                                    <circle cx="13.8203" cy="12.6999" r="8.1992" fill="#D72828" />
                                    <path
                                        d="M14.1524 11.3307C14.1368 10.7843 13.8753 10.2745 13.4402 9.94289C13.2176 9.80435 12.9701 9.71017 12.7117 9.66502C12.2455 9.90942 11.6882 9.90942 11.222 9.66502C10.9659 9.71095 10.7215 9.8059 10.5012 9.94289C10.0662 10.2737 9.80463 10.7843 9.78906 11.3307V14.4619H11.0173V18.8782H12.8876V14.4619H14.1439L14.1524 11.3307Z"
                                        fill="#F7F5F5" />
                                    <path
                                        d="M10.6817 8.23697C10.6747 7.52479 11.2468 6.9426 11.9582 6.93559C12.6704 6.92859 13.2525 7.50066 13.2596 8.21284C13.2666 8.92502 12.6945 9.50721 11.9831 9.51422C11.9792 9.51422 11.9745 9.51422 11.9706 9.51422C11.2639 9.51422 10.6879 8.94448 10.6817 8.23697Z"
                                        fill="#F7F5F5" />
                                    <path d="M9.82277 14.7936L8.70508 15.8942V18.8005L10.7031 16.8111V14.7936H9.82277Z" fill="#F7F5F5" />
                                    <path
                                        d="M15.0673 6.93107L16.4185 8.2737L14.2578 10.4102C14.401 10.6967 14.4804 11.0111 14.4905 11.331V13.0379L17.8265 9.7144L19.2384 11.1014V6.93107H15.0681H15.0673Z"
                                        fill="#F7F5F5" />
                                    <defs>
                                        <filter id="filter0_d_1_7888" x="1.36068" y="1.64275" width="24.7826" height="28.8101"
                                            filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                            <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                                result="hardAlpha" />
                                            <feOffset dy="1.33333" />
                                            <feGaussianBlur stdDeviation="1.33333" />
                                            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0" />
                                            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_7888" />
                                            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_7888" result="shape" />
                                        </filter>
                                    </defs>
                                </svg>
                            </div>
                            <template #content>
                                <div v-html="map_point.address ?? ''"></div>
                            </template>
                        </Popper>
                    </div>

                </div>
            </div>
        </div>
    </section>
</template>

<style>
 /* :root {
    --popper-theme-background-color: #282828;
    --popper-theme-background-color-hover: #333333;
    --popper-theme-text-color: #ffffff;
    --popper-theme-border-width: 0px;
    --popper-theme-border-style: solid;
    --popper-theme-border-radius: 5px;
    --popper-theme-padding: 20px;
    --popper-theme-box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.25);
  } */

/* .popper {
    min-width: 265px !important;
    color: #fff !important;
    background-color: #282828 !important;
    font-family: 'Roboto', sans-serif !important;
    font-weight: 300 !important;
    font-size: rem-calc(16) !important;
    line-height: rem-calc(27) !important;
    padding: rem-calc(20) !important;
    border-radius: 5px !important;
    box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.25) !important;

    a {
        color: inherit;
        text-decoration: underline;
    }
} */
</style>
